// Keys we use for the 'react-query' library, these need to be unique, so we are throwing them into an object to avoid
// accidentally adding duplicate keys https://react-query.tanstack.com/guides/query-keys.

/* eslint sort-keys: "error" -- Alphabetizing here to help us prevent duplicates */
const QUERY_KEYS = {
  activities: 'activities',
  activitiesPages: 'activitiesPages',
  allAssets: 'allAssets',
  arDashboard: 'arDashboard',
  arDashboardMonthlyData: 'arDashboardMonthlyData',
  assets: 'assets',
  assetsOnJob: 'assetsOnJob',
  assetsOnSite: 'assetsOnSite',
  billingStatusEnum: 'billingStatusEnum',
  client: 'client',
  clientImport: 'clientImport',
  clientImportRows: 'clientImportRows',
  clientImports: 'clientImports',
  clientJobs: 'clientJobs',
  clientQuickbooksCustomer: 'clientQuickbooksCustomer',
  clients: 'clients',
  clientsAll: 'clientsAll',
  createTicketPage: 'createTicketPage',
  dispatchPage: 'dispatchPage',
  dispatchResources: 'dispatchResources',
  dispatchSites: 'dispatchSites',
  dispatchTicket: 'dispatchTicket',
  dispatchTickets: 'dispatchTickets',
  dispatcherPayment: 'dispatcherPayment',
  dispatcherTransactions: 'dispatcherTransactions',
  editTicketPage: 'editTicketPage',
  feeType: 'feeType',
  feeTypeQuickbooksItem: 'feeTypeQuickbooksItem',
  feeTypes: 'feeTypes',
  hauler: 'hauler',
  invoice: 'invoice',
  invoiceByUUID: 'invoiceByUUID',
  invoiceInformation: 'invoiceInformation',
  invoiceJobEmails: 'invoiceJobEmails',
  invoicePaymentDetails: 'invoicePaymentDetails',
  invoicePreview: 'invoicePreview',
  invoiceSettings: 'invoiceSettings',
  invoices: 'invoices',
  invoicesAmountSummary: 'invoicesAmountSummary',
  job: 'job',
  jobsSearch: 'jobs',
  notifications: 'notifications',
  onlineScheduleCustomizations: 'onlineScheduleCustomizations',
  paymentTerms: 'paymentTerms',
  publicTermsAndCondition: 'publicTermsAndCondition',
  quickbooksCustomerTypesAndTaxCodes: 'quickbooksCustomerTypesAndTaxCodes',
  quickbooksFeeTypes: 'quickbooksFeeTypes',
  quickbooksTaxCodes: 'quickbooksTaxCodes',
  recurringTicket: 'recurringTicket',
  recurringTickets: 'recurringTickets',
  reports: 'reports',
  reportsDriverComparison: 'reportsDriverComparison',
  reportsFilters: 'reportsFilters',
  reportsTicketDetails: 'reportsTicketDetails',
  reportsTicketHeatmap: 'reportsTicketHeatmap',
  reportsTicketOverview: 'reportsTicketOverview',
  resourceAndTicketTypes: 'resourceAndTicketTypes',
  resourceImports: 'resourceImports',
  resourceType: 'resourceType',
  resourceTypes: 'resourceTypes',
  resourcesCharts: 'resourcesCharts',
  resourcesSearch: 'resourcesSearch',
  serviceRequests: 'serviceRequests',
  site: 'site',
  siteTypes: 'siteTypes',
  sites: 'sites',
  termsAndCondition: 'termsAndCondition',
  termsAndConditions: 'termsAndConditions',
  ticket: 'ticket',
  ticketFeesDiscountAndTax: 'ticketFeesDiscountAndTax',
  ticketNotifications: 'ticketNotifications',
  ticketType: 'ticketType',
  ticketTypes: 'ticketTypes',
  ticketsSearch: 'ticketsSearch',
  user: 'user',
  users: 'users',
  wastepayCustomerCardList: 'wastePayCustomerCardList',
  wastepayReceiptPreview: 'wastepayReceiptPreview',
  wastepaySessionToken: 'wastepaySessionToken',
  wastepayTransaction: 'wastepayTransaction',
  wastepayTransactions: 'wastepayTransactions',
  weightUnits: 'weightUnits'
}

export default QUERY_KEYS
